export class PlateConfigurationModel {
    constructor() {
    }

    public id: number;
    public plateTypeId: number;
    public foundationSequenceTypeId: number;
    public isPersonalized: boolean;
    public isDisabled: boolean;
}
